import { RemoteAppOption, UserSettings } from '../../types/user-settings';
import { UserSettingsFormData } from './models';

export const getUserSettingsPanelInitialValues = (incomingUserSettings: UserSettings): UserSettingsFormData =>
    UserSettingsFormData({ ...incomingUserSettings });

export const getUserSettingsSetFromFormData = (formData: UserSettingsFormData): UserSettings => {
    const { useMultiMonitor, themeMode } = formData;

    const settings: UserSettings = {
        themeMode: themeMode,
        useMultiMonitor: !!useMultiMonitor,
        preferredRemoteApp: RemoteAppOption.useWindowsApp, // Default to windows app
    };

    return settings;
};
